module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }